import React from 'react'
import styled from 'styled-components'
import Text from '../../Text'

import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'

const Footer = styled.div`
  display: flex;
  margin-top: 1.25rem;
`

const StyledContinueButtonContainer = styled.div`
  margin-left: auto;
  button {
    min-width: auto !important;
  }
`

const CreditTermPayment = ({ onSubmit }) => {
  const title =
    'Our accounts team will contact you separately to request for payment details.'

  return (
    <>
      <Text>{title}</Text>
      <Footer>
        <NdsThemeProvider>
          <StyledContinueButtonContainer>
            <ButtonContained
              compact
              size="l"
              onClick={onSubmit}
              data-testid="checkout-credit-term-continue-button"
            >
              Continue
            </ButtonContained>
          </StyledContinueButtonContainer>
        </NdsThemeProvider>
      </Footer>
    </>
  )
}

export default CreditTermPayment
